import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { requestTiers, requestTiersFailure, requestTiersSuccess } from './actions';
const reducers = handleActions({
    [requestTiers.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'fetching'
        }),
    [requestTiersSuccess.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'idle',
            tiers: action.payload.tiers
        }),
    [requestTiersFailure.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'error',
            errorMessage: action.payload.error
        })
}, {
    tiers: [],
    requestStatus: 'idle'
});
export default reducers;

//# sourceMappingURL=tierListReducer.js.map